import { useState, type ReactNode } from 'react';
import styles from './Grow.module.css';

/**
 * Something new entering a card or a list the reader already sees grows its own height from zero, so what is
 * under it moves down smoothly instead of jumping. The wrapper drops its classes once grown, so nothing stays
 * clipped. `gap` is the container's gap above it, which the growth takes in too.
 */
export function Grow({ active, delayMs, gap = 0, children }: { active: boolean; delayMs: number; gap?: number; children: ReactNode }) {
  const [grown, setGrown] = useState(false);
  if (!active) return <>{children}</>;
  return (
    <div
      className={grown ? undefined : styles.grow}
      style={grown ? undefined : { animationDelay: `${delayMs}ms`, ['--grow-gap' as string]: `${gap}px` }}
      onAnimationEnd={(e) => {
        if (e.target === e.currentTarget) setGrown(true);
      }}
    >
      <div className={grown ? undefined : styles.inner}>{children}</div>
    </div>
  );
}
